import React from 'react'
import withStyles from '@mui/styles/withStyles'
import { Card } from '@mui/material'
import FeedPostTopModel from '../../../feedsSystem/FeedPostTopModel'
import DarkModeColorCoder from '../../../smallComponents/DarkModeColorCoder'

const styles = () => ({
  postContainer: {
    width: '85%',
    borderRadius: 10,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 10,
  },
  postWrapper: {
    padding: '0 !important',
    borderRadius: '20px !important',
  },

  '@media (max-width: 600px)': {
    postContainer: {
      marginTop: 7,
      width: '100%',
    },
    postWrapper: {
      borderRadius: '0px !important',
    },
  },
})

const HomePostConatinerModel = ({ mainBody, classes, postProps }) => {
  const { isDarkModeActive, shared } = postProps
  return (
    <div className={classes.postContainer} style={{ width: shared && '100%' }}>
      <Card
        className={classes.postWrapper}
        sx={{
          color: isDarkModeActive
            ? DarkModeColorCoder('Text_white')
            : 'inherit',
          background: isDarkModeActive
            ? DarkModeColorCoder('Grey_light')
            : 'white',
        }}
      >
        <FeedPostTopModel postProps={postProps} />
        {mainBody}
      </Card>
    </div>
  )
}

const WrappedHomePostConatinerModel = withStyles(styles)(HomePostConatinerModel)

export default WrappedHomePostConatinerModel
